export const inIframe = (): boolean => {
    try {
        return window.self !== window.top;
    } catch (e2) {
        return window !== window.parent;
    }
    // Note - I also considered !!window.frameElement but it is not suitable when the iframe page has a different origin
    // to the hosting page. In these cases it will return null which is not correct in determining whether the page
    // is running within a frame.
};
